import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "hidden", "selected"]
  static values = {
    url: { type: String, default: "/search/taskables" }
  }

  connect() {
    this.timeout = null
    this.boundClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.boundClickOutside)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
    document.removeEventListener("click", this.boundClickOutside)
  }

  search() {
    const query = this.inputTarget.value.trim()
    console.log("[TaskableSearch] search called, query:", query)

    if (query.length < 2) {
      this.hideResults()
      return
    }

    if (this.timeout) clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      this.fetchResults(query)
    }, 200)
  }

  async fetchResults(query) {
    try {
      const sep = this.urlValue.includes("?") ? "&" : "?"
      const url = this.urlValue + sep + "q=" + encodeURIComponent(query)
      console.log("[TaskableSearch] Fetching:", url)
      const response = await fetch(url, { headers: { "Accept": "application/json" } })
      console.log("[TaskableSearch] Response status:", response.status)
      const results = await response.json()
      console.log("[TaskableSearch] Results:", results.length)
      this.displayResults(results)
    } catch (error) {
      console.error("[TaskableSearch] Error:", error)
    }
  }

  displayResults(results) {
    if (results.length === 0) {
      this.resultsTarget.innerHTML = '<div class="px-3 py-2 text-sm text-text-muted">Aucun resultat</div>'
    } else {
      this.resultsTarget.innerHTML = results.map(r => this.renderResult(r)).join("")
    }
    this.showResults()
  }

  renderResult(r) {
    const subtitle = r.subtitle ? '<div class="text-xs text-text-muted truncate">' + this.escapeHtml(r.subtitle) + '</div>' : ''
    const badgeClass = this.typeBadgeClass(r.type)
    return '<button type="button" ' +
      'class="w-full text-left px-3 py-2 hover:bg-gold/10 transition-colors flex items-center justify-between gap-2" ' +
      'data-action="click->taskable-search#select" ' +
      'data-id="' + r.id + '" ' +
      'data-label="' + this.escapeHtml(r.label) + '" ' +
      'data-type-label="' + this.escapeHtml(r.type_label) + '">' +
      '<div class="min-w-0">' +
        '<div class="text-sm font-medium text-text-primary truncate">' + this.escapeHtml(r.label) + '</div>' +
        subtitle +
      '</div>' +
      '<span class="flex-shrink-0 px-1.5 py-0.5 text-[9px] font-semibold rounded ' + badgeClass + '">' + this.escapeHtml(r.type_label) + '</span>' +
    '</button>'
  }

  typeBadgeClass(type) {
    const classes = {
      Contact: "bg-blue-500/10 text-blue-400",
      ContactB2c: "bg-purple-500/10 text-purple-400",
      Account: "bg-emerald-500/10 text-emerald-400",
      Deal: "bg-gold/10 text-gold",
      DealB2c: "bg-amber-500/10 text-amber-400"
    }
    return classes[type] || "bg-surface-3 text-text-muted"
  }

  select(event) {
    const button = event.currentTarget
    const id = button.dataset.id
    const label = button.dataset.label
    const typeLabel = button.dataset.typeLabel

    this.hiddenTarget.value = id
    this.inputTarget.value = ""
    this.selectedTarget.innerHTML =
      '<div class="flex items-center gap-2 px-3 py-2 bg-surface-2 rounded-lg border border-border-subtle min-w-0">' +
        '<span class="px-1.5 py-0.5 text-[9px] font-semibold rounded bg-gold/10 text-gold whitespace-nowrap">' + this.escapeHtml(typeLabel) + '</span>' +
        '<span class="text-sm text-text-primary truncate">' + this.escapeHtml(label) + '</span>' +
        '<button type="button" class="flex-shrink-0 ml-auto text-text-muted hover:text-danger transition-colors" data-action="click->taskable-search#clear">' +
          '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">' +
            '<path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />' +
          '</svg>' +
        '</button>' +
      '</div>'
    this.selectedTarget.classList.remove("hidden")
    this.inputTarget.classList.add("hidden")
    this.hideResults()
  }

  clear(event) {
    event.preventDefault()
    this.hiddenTarget.value = ""
    this.selectedTarget.innerHTML = ""
    this.selectedTarget.classList.add("hidden")
    this.inputTarget.classList.remove("hidden")
    this.inputTarget.focus()
  }

  showResults() {
    this.resultsTarget.classList.remove("hidden")
  }

  hideResults() {
    this.resultsTarget.classList.add("hidden")
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults()
    }
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text || ""
    return div.innerHTML
  }
}
